<template>
  <div class="stack">
    <Header :isbig="true"></Header>
    <div class="content" v-bind:style="{ minHeight: minheight + 'px' }">
      <div class="searchResult clearfix" v-if="$route.query.searchValue">
        <span class="searchmain">{{ searchInfo }}</span
        ><span>的搜索结果</span><span class="num">（{{ totalPage }}）</span
        ><span>:</span>
      </div>
      <div class="searchbox"></div>
      <div class="sortList">
        <ul>
          <li class="clearfix">
            <span class="fl">频道：</span>
            <div class="right fl">
              <a
                href="javaScript:"
                :class="{ active: group == 1 }"
                @click="chooseType(1)"
                >男频</a
              >
              <a
                href="javaScript:"
                :class="{ active: group == 2 }"
                @click="chooseType(2)"
                >女频</a
              >
            </div>
          </li>
          <li class="clearfix">
            <span class="fl">
              分类：
            </span>
            <div class="right fl sortitem">
              <a
                href="javaScript:"
                @click="chooseSort(-1)"
                :class="{ active: sortValue.sort == -1 }"
                >全部</a
              >
              <a
                href="javaScript:"
                v-for="item in sortList"
                @click="chooseSort(item.sortId)"
                :key="item.sortId"
                :class="{ active: sortValue.sort == item.sortId }"
                >{{ item.name }}</a
              >
            </div>
          </li>
          <li v-for="item in conditionsList" :key="item.key" class="clearfix">
            <span class="fl">{{ item.desc }}：</span>
            <div class="right fl">
              <a
                href="javaScript:"
                v-for="sort in item.values"
                :key="sort.code"
                @click="chooseCode(sort.code, item.key)"
                :class="{ active: sortValue[item.key] == sort.code }"
                >{{ sort.desc }}</a
              >
            </div>
          </li>
        </ul>
      </div>
      <div class="sortTitle clearfix">
        <a
          href="javaScript:"
          class="fr"
          @click="chooseOrder"
          v-if="!$route.query.searchValue"
        >
          <img v-show="isorder" src="~img/book/list_2@2x.png" alt="" />
          <img v-show="!isorder" src="~img/book/list_3@2x.png" alt="" />
        </a>
      </div>
      <div class="sortContent" v-if="!$route.query.searchValue">
        <div v-show="isorder" class="section section1" id="stackShelf">
          <div class="main" style="border: none;padding:0px">
            <ul class="clearfix" v-show="booklist.length > 0 && isLoad">
              <li v-for="book in booklist" class="fl" :key="book.id">
                <dl class="main-dl clearfix">
                  <dt class="fl">
                    <router-Link :to="'/bookdetail/' + book.id"
                      ><img
                        v-lazy="imgURL + book.iconUrlSmall"
                        width="120"
                        height="168"
                        alt="book.name"
                      />
                    </router-Link>
                  </dt>
                  <dd class="main-dd fl">
                    <div>
                      <router-Link :to="'/bookdetail/' + book.id">
                        <h4 :title="book.name">{{ book.name }}</h4>
                      </router-Link>
                      <div class="flex">
                        <a href="#">{{ book.authorname }}</a>
                        |
                        <a href="javaScript">
                          <em>{{ book.sortName }}</em>
                        </a>
                        |
                        <a href="javaScript:" class="name">
                          <em>{{ book.words }}字</em>
                        </a>
                        |
                        <em>{{ book.finished }}</em>
                      </div>
                      <p class="summary">
                        {{ book.introduce }}
                      </p>
                      <div class="newbox">
                        <router-link
                          :to="'/book/' + book.id + '/' + book.lastchapterid"
                          class="left"
                          >最新更新：{{ book.lastchaptername }}</router-link
                        >
                        <span>{{ book.lastchaptertime }}</span>
                      </div>
                    </div>
                  </dd>
                </dl>
              </li>
            </ul>
            <noneHint
              v-show="booklist.length <= 0 && !isLoad"
              :noneListhint="noneListhint"
            ></noneHint>
          </div>
        </div>
        <div class="sorttable" v-show="!isorder">
          <el-table
            :data="booklist"
            style="width: 100%"
            @row-click="chooseTable"
          >
            <el-table-column class="type" label="类别" width="100px">
              <template scope="scope">
                <span style="margin-left: 10px"
                  >「{{ scope.row.sortName }}」</span
                >
              </template>
            </el-table-column>
            <el-table-column prop="name" label="书名" width="180">
            </el-table-column>
            <el-table-column
              prop="lastchaptername"
              label="最新章节"
              width="250px"
            >
            </el-table-column>
            <el-table-column prop="finished" label="状态" width="100">
            </el-table-column>
            <el-table-column prop="authorname" label="作者"> </el-table-column>
            <el-table-column
              prop="lastchaptertime"
              label="更新时间"
            ></el-table-column>
          </el-table>
        </div>
        <el-pagination
          background
          layout="total, jumper, prev, pager, next"
          :page-size="20"
          :total="totalPage"
          class="paginnation-book sortpage"
          :current-page.sync="currentPage"
          @current-change="currentChoose"
        >
        </el-pagination>
      </div>
      <div class="query clearfix" v-if="$route.query.searchValue">
        <div class="clearfix" v-show="booklist.length > 0">
          <div class="searchbox fl">
            <div class="section section1" id="stackShelf">
              <div class="main" style="border: none;padding:0px">
                <ul class="clearfix">
                  <li v-for="book in booklist" class="fl" :key="book.id">
                    <dl class="main-dl clearfix">
                      <dt class="fl">
                        <router-Link :to="'/bookdetail/' + book.id"
                          ><img
                            v-lazy="imgURL + book.iconUrlSmall"
                            width="120"
                            height="168"
                            alt="book.name"
                          />
                        </router-Link>
                      </dt>
                      <dd class="main-dd fl">
                        <div>
                          <router-Link :to="'/bookdetail/' + book.id">
                            <h4 :title="book.name" v-html="book.name"></h4>
                          </router-Link>
                          <div class="flex">
                            <a href="#" v-html="book.authorname"></a>
                            |
                            <a href="javaScript" target="_blank">
                              <em>{{ book.sortName }}</em>
                            </a>
                            |
                            <a href="javaScript:" class="name" target="_blank">
                              <em>{{ book.words }}字</em>
                            </a>
                            |
                            <em>{{ book.finished ? "已完结" : "连载中" }}</em>
                          </div>
                          <p class="summary" v-html="book.introduce"></p>
                        </div>
                      </dd>
                    </dl>
                  </li>
                </ul>
              </div>
            </div>
            <el-pagination
              background
              layout="total, jumper, prev, pager, next"
              :page-size="10"
              :total="totalPage"
              class="paginnation-book sortpage"
              :current-page.sync="searchPage"
              @current-change="searchChoose"
            >
            </el-pagination>
          </div>
          <div class="moreShelf fl">
            <div class="title">大家都在读</div>
            <div class="section section1" id="stackShelf">
              <div class="main" style="border: none;padding:0px">
                <ul>
                  <li v-for="book in shelf1" :key="book.id">
                    <dl class="main-dl clearfix">
                      <dt class="fl">
                        <router-Link :to="'/bookdetail/' + book.id"
                          ><img
                            v-lazy="imgURL + book.iconUrl"
                            width="120"
                            height="168"
                            alt="book.name"
                          />
                        </router-Link>
                      </dt>
                      <dd class="main-dd fl">
                        <div>
                          <router-Link
                            :to="'/bookdetail/' + book.id"
                            target="_blank"
                          >
                            <h4 :title="book.name" v-html="book.name"></h4>
                          </router-Link>
                          <a
                            href="#"
                            class="author"
                            v-html="book.author.name"
                          ></a>
                          <div class="flex">
                            <a href="javaScript" target="_blank">
                              <em>{{ book.sort }}</em>
                            </a>
                            |
                            <a href="javaScript:" class="name" target="_blank">
                              <em>{{ book.words }}字</em>
                            </a>
                            |
                            <em>{{ book.finished ? "已完结" : "连载中" }}</em>
                          </div>
                        </div>
                      </dd>
                    </dl>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        <div v-show="booklist.length <= 0">
          <noneHint :noneListhint="noneListhint"></noneHint>
          <div class="workInfomation">
            <h3 class="clearfix">
              <p class="fl">看这本书的人还看这些</p>
            </h3>
            <sixRecommend :booklist="shelf1" :isNewWindow="true"></sixRecommend>
          </div>
        </div>
      </div>
    </div>
    <Footer></Footer>
  </div>
</template>

<script>
import { moreshelf } from "@/api/book";
import { sortAll, conditions, sortList, searchAll } from "apiurl/search";
export default {
  data() {
    return {
      booklist: [],
      isLoad: true,
      group: 1,
      minheight: null,
      noneListhint: {
        msg: "啊哦...没有相关资源呢，源石会努力引入好作品，先看看其他作品吧！",
        btnmsg: "创建作品",
        isbtn: false,
        istype: "book"
      },
      isorder: true,
      stop: true,
      conditionsList: [],
      totalPage: 0,
      currentPage: 1,
      searchPage: 1,
      searchInfo: "",
      sortList: [],
      boyList: null,
      girlList: null,
      sortValue: {
        sort: -1,
        finish: -1,
        words: -1,
        free: -1
      },
      shelf1: []
    };
  },
  created() {
    this.$nextTick(() => {
      /*====下拉触底加载监听*/
      //   $(window).on("scroll", this.scrollbottom);
      this.getconditions();
      this.getNanSort();
      //   this.bookShelf(1);
      this.getmoreshelf();
      if (this.$route.query.searchValue) {
        this.searchInfo =
          this.$route.query.searchValue.length > 20
            ? this.$route.query.searchValue.substring(0, 20) + "..."
            : this.$route.query.searchValue;
        this.booklist = [];
        this.totalPage = 0;
        this.getSearch(this.$route.query.searchValue, 1);
      } else {
        this.getSortList(1);
      }
    });
  },
  watch: {
    $route: function(newVal) {
      if (newVal.query.searchValue) {
        this.booklist = [];
        this.totalPage = 0;
        this.searchInfo =
          newVal.query.searchValue.length > 20
            ? newVal.query.searchValue.substring(0, 20) + "..."
            : newVal.query.searchValue;
        this.getSearch(newVal.query.searchValue, 1);
      } else {
        this.getSortList(1);
      }
    }
  },
  methods: {
    // 获取条件
    getconditions() {
      conditions().then(res => {
        if (res.success) {
          this.conditionsList = res.data;
        }
      });
    },
    // 获取分类列表
    async getNanSort() {
      let nanres = await sortList({ group: 1 });
      let nvres = await sortList({ group: 2 });
      if (nanres.success) {
        this.boyList = nanres.data;
      }
      if (nvres.success) {
        this.girlList = nvres.data;
      }
      this.sortList = [...this.boyList];
    },
    getmoreshelf() {
      moreshelf({ shelfId: "yuanshi_web_same_like" }).then(res => {
        if (res.success) {
          this.shelf1 = res.data.items;
          this.shelf1.forEach(items => {
            items.introduce = items.introduce.substring(0, 40) + "...";
          });
        }
      });
    },
    // 选择展示模式
    chooseOrder() {
      this.isorder = !this.isorder;
    },
    chooseType(type) {
      // 切换分类
      this.group = type;
      this.sortValue.sort = -1;
      if (type == 1) {
        this.sortList = this.boyList;
      } else {
        this.sortList = this.girlList;
      }
    },
    chooseSort(id) {
      this.sortValue.sort = id;
      if (this.$route.query.searchValue) {
        this.getSearch(this.$route.query.searchValue, 1);
      } else {
        this.getSortList(1);
      }
    },
    chooseCode(code, key) {
      this.sortValue[key] = code;
      if (this.$route.query.searchValue) {
        this.getSearch(this.$route.query.searchValue, 1);
      } else {
        this.getSortList(1);
      }
    },
    async getSortList(pageNum) {
      let res = await sortAll({
        sort: this.sortValue.sort == -1 ? "" : this.sortValue.sort,
        page: pageNum,
        size: 20,
        finish:
          this.sortValue.finish == -1
            ? ""
            : this.sortValue.finish == 0
            ? false
            : true,
        free:
          this.sortValue.free == -1
            ? ""
            : this.sortValue.free == 0
            ? false
            : true,
        words: this.sortValue.words,
        group: this.group
      });
      if (res.success) {
        res.data.content.forEach(item => {
          item.introduce = item.introduce.substring(0, 50) + "...";
          item.finished = item.finished == true ? "已完结" : "连载中";
          item.lastchaptertime = item.lastchaptertime.slice(0, 10);
        });
        this.hasNextPage = res.data.last;
        this.currentPage = pageNum;
        document.body.scrollTop = 0;
        document.documentElement.scrollTop = 0;
        this.booklist = [...res.data.content];
        if (this.booklist.length > 0) {
          this.isLoad = true;
        } else {
          this.isLoad = false;
        }
        this.totalPage = Number(res.data.totalElements);
      }
    },
    getSearch(queryString, pageNum) {
      searchAll({
        page: pageNum,
        size: 10,
        queryString,
        sort: this.sortValue.sort == -1 ? "" : this.sortValue.sort,
        finish:
          this.sortValue.finish == -1
            ? ""
            : this.sortValue.finish == 0
            ? false
            : true,
        free:
          this.sortValue.free == -1
            ? ""
            : this.sortValue.free == 0
            ? false
            : true,
        words: this.sortValue.words
      }).then(res => {
        if (res.success) {
          res.data.content.forEach(item => {
            item.introduce = item.introduce.substring(0, 50) + "...";
          });
          this.searchPage = pageNum;
          document.body.scrollTop = 0;
          document.documentElement.scrollTop = 0;
          this.booklist = [...res.data.content];
          if (this.booklist.length > 0) {
            this.isLoad = true;
          } else {
            this.isLoad = false;
          }
          this.totalPage = Number(res.data.totalElements);
        }
      });
    },
    // 选择指定的页数
    currentChoose(value) {
      this.getSortList(value);
    },
    searchChoose(value) {
      this.getSearch(this.$route.query.searchValue, value);
    },
    chooseTable(row) {
      this.$router.push(`/bookdetail/${row.id}`);
    }
  },
  mounted() {
    //动态设置内容高度 让footer始终居底   header+footer的高度是100
    this.minheight = document.documentElement.clientHeight - 200; //监听浏览器窗口变化
    window.onresize = () => {
      this.minheight = document.documentElement.clientHeight - 200;
    };
  },
  beforeDestroy() {
    $(window).off("scroll");
  }
};
</script>
<style>
.el-pagination__editor.el-input .el-input__inner {
  height: 24px;
}
.el-pagination__jump {
  margin-right: 10px;
  margin-left: 0px;
}
.sorttable {
  padding-bottom: 80px;
}
.sorttable .el-table td {
  padding: 7px 0;
  border-bottom: 1px dashed #e5e5e5;
}
.sorttable .el-table__row {
  color: #999;
  font-size: 12px;
  cursor: pointer;
}
.sorttable tr td:nth-child(2) {
  color: #666666;
}
.sorttable .has-gutter .el-table_1_column_1 {
  padding-left: 20px;
}
.sorttable .has-gutter th {
  padding: 20px 0 20px 20px;
  color: #666;
}
.sorttable .el-table__body {
  padding-left: 20px;
}
.sorttable .cell {
  height: 23px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>

<style lang="stylus" scoped>
.stack
    background:rgba(249,249,249,1);
.content
    width 1016px
    margin 22px auto 0
    .sortList
        li
            margin-bottom 4px
            span
                color #333333
                font-size:14px;
                line-height:24px;
                margin-right 14px
            .right
                width 790px
                a
                    padding 5px 14px
                    color #333
                    display inline-block
                    background:rgba(255,255,255,1);
                    box-shadow:0px 1px 3px 0px rgba(0,0,0,0.1);
                    border-radius:4px;
                    margin-right 14px
                    display inline-block
                    margin-bottom 16px
                    font-size 14px
                    &.active
                        background #48A2DF
                        color #fff
    .sortTitle
        width:1016px;
        height:48px;
        background:rgba(241,242,244,1);
        a
            margin-top 16px
            margin-right 20px
            img
                width 16px
                height 16px
    .sortpage
        position absolute
        bottom 18px
        right 25px
.sortContent
    position relative
    background:#fff;
    margin-top 20px
.query
    background:#fff;
    margin-top 20px
.searchbox
    position relative
    width 676px
    background:#fff;
    #stackShelf
        .main
            width 676px
            ul
                li
                    width 654px
                    dd
                        margin-left 0px
                        width 507px
                        h4
                            margin-bottom 8px
                        .flex
                            margin-bottom 20px
#stackShelf
    margin-top 1px
    padding-top 0px
    padding-bottom 150px
    .main
        width 1016px
        ul
            background #fff
            padding-left 25px
            li
                width 458px
                height auto
                margin-right 50px
                box-shadow 0 0 0 0 rgba(0, 0, 0, 0.13)
                margin-top 0
                margin-bottom 0
                border-bottom 1px solid #e5e5e5
                padding 0 0 20px 0
                &:nth-child(2n)
                    margin-right 0px
                dl
                    &:hover
                        dt
                            a
                                img
                                    transform scale(1)
                                    width 123px
                                    height 175px
                    dt
                        a
                            position static
                            width 122px
                            height 175px
                            top 0px
                            img
                                width 123px
                                height 175px
                                transition none
                                margin-top 17px
                                margin-right 15px
                                box-shadow:-2px 4px 6px 0px rgba(0,0,0,0.2);
                                border-radius:2px;
                    dd
                        margin-left 0px
                        width 320px
                        position relative
                        h4
                            margin-bottom 8px
                        .flex
                            margin-bottom 20px
                        .newbox
                            color #999
                            font-size 12px
                            margin-top 25px
                            .left
                                color #5B6B8B
                                dispaly inline-block
                                margin-right 20px
.moreShelf
    width:290px;
    border:1px solid rgba(229,229,229,1);
    margin-left 30px
    margin-top 15px
    .title
        height 57px
        line-height 57px
        border-bottom 2px solid #e5e5e5
        font-size 18px
        padding-left 20px
        color #333
    #stackShelf
        padding-bottom 20px
        .main
            width 290px
            ul
                background #fff
                padding-left 20px
                li
                    width 250px
                    height auto
                    margin-right 20px
                    box-shadow 0 0 0 0 rgba(0, 0, 0, 0.13)
                    margin-top 0
                    margin-bottom 0
                    border-bottom none
                    padding 0
                    &:nth-child(2n)
                        margin-right 0px
                    dl
                        &:hover
                            dt
                                a
                                    img
                                        transform scale(1)
                                        width 64px
                                        height 84px
                        dt
                            a
                                position static
                                width 64px
                                height 84px
                                top 0px
                                img
                                    width 64px
                                    height 84px
                                    transition none
                                    margin-top 17px
                                    margin-right 15px
                                    box-shadow:0 0 0 0 rgba(0,0,0,0.2);
                                    border-radius:2px;
                        dd
                            margin-left 0px
                            width 166px
                            h4
                                margin-bottom 20px
                                font-size 14px
                                margin-top 17px
                            .author
                                margin-bottom 11px
                            .flex
                                margin-bottom 0px
.searchResult
    margin-bottom 20px
    span
        display inline-block
        color #999
        font-size 14px
    .searchmain
        font-size 30px
        margin-right 5px
        color #333
    .num
        color #5B6B8B
        font-size 14px
.workInfomation
            margin-top 19px
            margin-left 26px
            h3
                height 22px
                line-height 22px
                padding 0
                color rgba(51, 51, 51, 1)
                background #fff
                p
                    height 22px
                    line-height 22px
                    color #333333
                    font-size 16px
                    font-family PingFangSC
                    font-weight 600
</style>
